import React from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'

import useDataLayer from '@hooks/useDataLayer'
import useRouteBuilder from '@hooks/useRouteBuilder'
import useFunnelStage from '@hooks/useFunnelStage'
import setBrokerFunnelStage from '@client/services/funnel'

import DynamicFlow from '@components/DynamicFlow'

import BrokerCommercialOffer from '@pages/BrokerCommercialOffer'
import BrokerCompanyInfo from '@pages/BrokerCompanyInfo'

export default function BrokerAcquisitionFlow() {
  const { setFunnelStage } = useFunnelStage('United Kingdom')
  const history = useHistory()
  const match = useRouteMatch()

  const { events } = useDataLayer()
  const { buildRoute } = useRouteBuilder()

  let dataLayer = {}

  function setDataLayer(step, path, newDataLayer) {
    dataLayer = { ...dataLayer, ...newDataLayer }
    events.simulatorInteractionWithSteps(step, path, dataLayer)
  }

  function changePage(path) {
    history.push(path)
  }

  function onLoad(data) {
    setFunnelStage(data)
  }

  return (
    <DynamicFlow
      onLoad={onLoad}
      actions={{ setFunnelStage, setDataLayer }}
      changePage={changePage}
      origin={match.url}
    >
      <BrokerCompanyInfo
        actions={{ setFunnelStage, setDataLayer }}
        step={1}
        path={buildRoute('/broker/simulate/company-info')}
      />
      <BrokerCommercialOffer
        actions={{ setBrokerFunnelStage }}
        path={buildRoute('/broker/simulate/commercial-offer')}
      />
    </DynamicFlow>
  )
}
